import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import EditorDialog from "./EditorDialog";
import { EDITOR_ACCENT } from "../editorUiConstants";

const HtmlEditorDialog = ({ open, initialValue, onClose, onSave, title = "Modifica HTML" }) => {
  const [value, setValue] = useState(initialValue || "");

  useEffect(() => {
    if (open) {
      setValue(initialValue || "");
    }
  }, [open, initialValue]);

  return (
    <EditorDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ textAlign: "center", color: EDITOR_ACCENT, fontWeight: 800 }}>{title}</DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          multiline
          minRows={14}
          maxRows={24}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="<table>...</table>"
          sx={{
            mt: 0.5,
            "& .MuiInputBase-root": {
              fontFamily: "Consolas, Monaco, \"Courier New\", monospace",
              fontSize: 13,
              lineHeight: 1.5,
            },
          }}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2, gap: 1 }}>
        <Button onClick={onClose} sx={{ borderRadius: 0 }}>
          Annulla
        </Button>
        <Button
          variant="contained"
          sx={{ borderRadius: 0, bgcolor: EDITOR_ACCENT }}
          onClick={() => onSave(value)}
        >
          Applica
        </Button>
      </DialogActions>
    </EditorDialog>
  );
};

HtmlEditorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  initialValue: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default HtmlEditorDialog;
 